import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  CardMedia,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { UseAddOrder } from "./UseAddOrder";
import { useSnackbar } from "notistack";
import "leaflet/dist/leaflet.css";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function UserDetail(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { GetUserInfo, GetExpressDeliveryCost } = UseAddOrder();
  const { isSmall } = useBreakpoints();

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={props.state.firstName ? props.state.firstName : ""}
          error={props.errorState.firstName}
          label="نام"
          size="small"
          type="text"
          autoComplete="off"
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, firstName: evt.target.value });
          }}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.lastName ? props.state.lastName : ""}
          error={props.errorState.lastName}
          label="نام خانوادگی"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, lastName: evt.target.value });
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
        gridColumn={isSmall ? "span 12" : "span 6"}
      >
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.mobile ? props.state.mobile : ""}
          label="تلفن همراه"
          size="small"
          error={props.errorState.mobile}
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, mobile: evt.target.value });
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              GetUserInfo(props.state.mobile, (callback) => {
                props.setState({
                  ...props.state,
                  firstName: callback.user?.firstName
                    ? callback.user.firstName
                    : "",
                  lastName: callback.user?.lastName
                    ? callback.user.lastName
                    : "",
                  mobile: callback.user?.mobile ? callback.user.mobile : "",
                });
              });
            }
          }}
          sx={{ input: { direction: "rtl" } }}
        />
        <Button
          sx={{ ml: 1, width: isSmall ? "100%" : "40%" }}
          variant="contained"
          onClick={() => {
            GetUserInfo(props.state.mobile, (callback) => {
              if (callback.user?.mobile) {
                props.setGetPayment(callback.user.mobile);
              }
              props.setState({
                ...props.state,
                firstName: callback.user.firstName
                  ? callback.user.firstName
                  : "",
                lastName: callback.user?.lastName ? callback.user.lastName : "",
                mobile: callback.user?.mobile ? callback.user.mobile : "",
              });
            });
          }}
        >
          اطلاعات
        </Button>
        <Button
          sx={{ ml: 1, width: "40%" }}
          variant="contained"
          color="secondary"
          onClick={() => {
            GetUserInfo(props.state.mobile, (callback) => {
              if (callback.addresses == null) {
                enqueueSnackbar("آطلاعات آدرس یافت نشد", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
              } else if (callback.addresses && callback.addresses.length > 1) {
                props.setOpenAddress({
                  show: true,
                  addresses: callback.addresses,
                });
              } else {
                props.setState({
                  ...props.state,
                  address: callback.addresses
                    ? callback.addresses[0].address
                    : "",
                  provinceID: callback.addresses
                    ? callback.addresses[0].provinceID
                    : "",
                  cityID: callback.addresses
                    ? callback.addresses[0].cityID
                    : "",
                  neighbourhoodID: callback.addresses
                    ? callback.addresses[0].neighbourhoodID
                    : "",
                  longitude: callback.addresses
                    ? callback.addresses[0].longitude
                    : "",
                  latitude: callback.addresses
                    ? callback.addresses[0].latitude
                    : "",
                });
              }
            });
          }}
        >
          آدرس
        </Button>
      </Box>
      <Box gridColumn={isSmall ? "span 6" : "span 3"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.phone ? props.state.phone : ""}
          label="تلفن ثابت"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, phone: evt.target.value });
          }}
          sx={{
            input: { direction: "rtl" },
          }}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 6" : "span 3"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.postCode ? props.state.postCode : ""}
          label="کد پستی"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, postCode: evt.target.value });
          }}
          sx={{
            input: { direction: "rtl" },
          }}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.address ? props.state.address : ""}
          label="آدرس"
          size="small"
          error={props.errorState.address}
          variant="outlined"
          multiline
          rows={4}
          onChange={(evt) => {
            props.setMyLocations({
              ...props.myLocations,
              address: evt.target.value,
            });
            props.setState({ ...props.state, address: evt.target.value });
          }}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state.description ? props.state.description : ""}
          label="توضیحات"
          multiline
          rows={4}
          size="small"
          variant="outlined"
          onChange={(evt) => {
            props.setState({ ...props.state, description: evt.target.value });
          }}
        />
      </Box>
    </Box>
  );
}
